import type { Locale } from "@/config/i18n";
import { tr } from "@/config/localeText";
import { CONTACT_UI } from "@/(global)/contact/components/contactDict";

export const SeoSections = ({
  locale = "fr",
}: {
  locale?: Locale;
}): JSX.Element => {
  const t = tr(CONTACT_UI, locale).seo;
  return (
    <section className="border-t border-black/10 py-16">
      <div className="mx-auto grid max-w-[90rem] grid-cols-1 gap-10 px-6 md:grid-cols-3 md:px-8">
        <div>
          <h2 className="mb-2 font-space-age text-xl tracking-[0.2em]">
            {t.zonesTitle}
          </h2>
          <p className="text-sm text-black/70">{t.zonesText}</p>
        </div>
        <div>
          <h2 className="mb-2 font-space-age text-xl tracking-[0.2em]">
            {t.proTitle}
          </h2>
          <p className="text-sm text-black/70">{t.proText}</p>
        </div>
        <div>
          <h2 className="mb-2 font-space-age text-xl tracking-[0.2em]">
            {t.qualityTitle}
          </h2>
          <p className="text-sm text-black/70">{t.qualityText}</p>
        </div>
      </div>
    </section>
  );
};
